<template>
  <StorageFooter
    v-if="data?.footer"
    v-bind="data.footer"
    class="mt-section-y"
  />
</template>

<script lang="ts" setup>
import type { FooterQueryVariables, Channel } from '#graphql-operations'

const props = defineProps<{
  channel: Channel
}>()

const language = useCurrentLanguage()

const variables = computed<FooterQueryVariables>(() => ({
  channel: props.channel,
}))

const key = computed(() => `app-footer-${language.value}-${props.channel}`)

const { data } = await useCachedAsyncData(
  key.value,
  () =>
    useGraphqlQuery('footer', variables.value, {
      graphqlCaching: {
        client: true,
      },
    }),
  {
    serverMaxAge: 60 * 60,
    clientMaxAge: 'never',
    serverCacheTags: (data) => {
      return data.extensions?.cacheability?.tagsNuxt || []
    },
    transform: function (data) {
      const footer = data.data.footer
      const cacheability = data.extensions?.cacheability
      return { footer, cacheability }
    },
    watch: [language, variables],
    deep: false,
  },
)

useGraphqlCacheability(data.value)
</script>
